
export const lightTheme = {
    token: {
      colorPrimary: '#1DA57A',
      colorLink: '#1890ff',
      borderRadius: '4px',
      fontSizeBase: '16px',
      backgroundColor: '#ffffff',
      textColor: '#000000',
    },
    components: {
        Menu: {
          colorPrimary: '#1DA57A',
        },
      },
  };
  
// theme.js
export const darkTheme = {
    token: {
      colorPrimary: '#1DA57A',
      colorLink: '#1890ff',
      borderRadius: '4px',
      fontSizeBase: '16px',
      backgroundColor: '#141414', // Dark background
      textColor: '#ffffff', // Light text for dark theme
    },
    components: {
        Menu: {
          colorPrimary: '#1DA57A',
          backgroundColor: '#141414',
        },
      },
  };
  